<template>
  <div class="menu-mobile-primary">
    <MenuMobileHeader @stepBack="$emit('stepBack')" @close="$emit('close')">
      {{ mainMenu.catalogTitle }}
    </MenuMobileHeader>
    <div class="menu-mobile-primary__items">
      <a
        v-for="item in getItems"
        :href="item.href"
        class="menu-mobile-primary__item"
        :class="{ 'menu-mobile-primary__item_red': item.sectionID == 70 }"
      >
        {{ item.name }}
        <span v-if="item.items && item.items.length > 0" @click.prevent="openNextLevel(item)">
          <svg><use xlink:href="#svg-arrow-right"></use></svg>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MenuMobileHeader from '@components/Menu/MenuMobile/MenuMobileHeader.vue';

export default {
  name: 'MenuMobilePrimary',
  components: { MenuMobileHeader },
  computed: {
    ...mapState({
      mainMenu: ({ results }) => results.menus.mainMenu,
    }),
    items() {
      return this.mainMenu.items.filter((el) => !el.isCollection);
    },
    getItems() {
      return this.items.filter((el) => el.elementCnt !== 0);
    },
  },
  methods: {
    openNextLevel(item) {
      this.$emit('openSecondLevel', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile-primary {
  position: fixed;
  z-index: 3;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: #f5f5f5;
  &__items {
    display: grid;
    grid-auto-rows: 48px;
    grid-row-gap: 8px;
    overflow-y: auto;
    max-height: 100%;
    padding: 8px 16px 0;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    background-color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    svg {
      height: 20px;
      width: 20px;
    }
    &_red {
      color: var(--color-red);
    }
  }
}
</style>
